<template>
  <el-dialog v-loading="isLoading" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh"
    :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">支付账单</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-radio-group class="paymentType-group" v-model="dataModel.paymentTypeId">
        <el-row>
          <el-col :span="6" class="paymentType-item" v-for="(item, index) in autonomousPaymentTypes" :key="index">
            <el-tooltip effect="light" :content="item.desc" placement="top">
              <el-card shadow="nerver" :body-style="{ padding: '0px' }">
                <el-link :underline="false" :disabled="paymentTypeDisabled" @click="onPaymentTypeIconClick(item.value)">
                  <i class="icon">
                    <img :src="paymentImgList[item.key]" />
                  </i>
                </el-link>
                <el-radio name="paymentType" :disabled="paymentTypeDisabled" :label="item.value">
                </el-radio>
              </el-card>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-radio-group>
      <div class="payment-info">
        <table>
          <tr>
            <td class="label">支付方式</td>
            <td>{{paymentName}}</td>
          </tr>
          <tr>
            <td class="label">账单费用</td>
            <td>{{data.paymentAmount|toCurrency(data.currency)}}</td>
          </tr>
          <tr v-if="!!pcPrice">
            <td class="label">手续费{{pcRateView}}</td>
            <td>{{pcPrice|toCurrency(data.currency)}}</td>
          </tr>
          <tr>
            <td class="label">支付金额</td>
            <td>{{data.paymentAmount+pcPrice|toCurrency(data.currency)}}</td>
          </tr>
          <tr>
            <td class="label">支付日期</td>
            <td>{{paymentDateText}}</td>
          </tr>

        </table>
      </div>
      <div class="payment-inputs">
        <el-form key="inputForm" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :model="dataModel" :rules="rules">
          <div v-if="dataModel.paymentTypeId === GLOBAL.enumPaymentType.emt">
            <hr />
            <p>请EMT正确的金额至速成账号 {{mailAccount}}
              并上传截图等待行政人员确认，<span class="cs-redLabel">截图内容需包含：
              姓名、电话、付款金额、支付成功的信息</span>，示例如下:</p>
            <div class="cs-emt-example-imgList">
              <el-row>
                <el-col>
                  <span>EMT付款流程图</span>
                  <img :src="emtExampleImgSrc" />
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <span>截图上传图片</span>
                  <img src="@/assets/emt_example_success.jpg"/>
                </el-col>
              </el-row>
            </div>
          </div>
          <table>
            <!-- 
            <tbody v-if="dataModel.paymentTypeId === GLOBAL.enumPaymentType.emt">
              <tr>
                <td class="label">
                  <div class="label__inner">姓名</div>
                </td>
                <td>
                  <el-form-item label-width="0" prop="name">
                    <el-input placeholder="请输入姓名" :disabled="readonly" v-model="dataModel.name" class="input-width" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <div class="label__inner">支付邮箱</div>
                </td>
                <td>
                  <el-form-item label-width="0" prop="email">
                    <el-input placeholder="请输入支付邮箱" :disabled="readonly" v-model="dataModel.email" class="input-width" />
                  </el-form-item>
                </td>
              </tr>
            </tbody>
            <tr>
              <td class="label">
                <div class="label__inner">支付备注</div>
              </td>
              <td>
                <el-form-item label-width="0" prop="comment">
                  <el-input :maxlength="500" placeholder="选填*请输入支付备注" type="textarea" rows="3" :disabled="readonly" v-model="dataModel.comment" class="input-width" />
                </el-form-item>
              </td>
            </tr> -->
            <tr v-if="dataModel.paymentTypeId === GLOBAL.enumPaymentType.emt">
              <td class="label">上传截图</td>
              <td>
                <el-row>
                  <el-col v-for="(item, index) in dataModel.imageFiles" :key="index" class="cs-demo-image__lazy">
                    <div class="block">
                      <a href="javascript:;" @click="showImagePreview(item.Path)">
                        <img :src="__convertImageUrl(item.Path)" :title="item.FileName" lazy>
                      </a>
                    </div>
                    <el-button v-if="!readonly" type="text" size="medium" @click="onRemoveImageClick(index)">删除</el-button>

                  </el-col>
                </el-row>
                <el-button v-if="!readonly" size="medium" type="primary" plain @click="openBlobUploader">本地上传</el-button>
              </td>
            </tr>
          </table>
        </el-form>
      </div>
    </div>
    <template v-if="!readonly" #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button type="primary" :disabled="isSaving" @click="completedPayment">{{dataModel.paymentTypeId === GLOBAL.enumPaymentType.emt ? "完成支付" : "前往支付"}}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </template>
    <template>
      <el-dialog center title="上传截图" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="blobUploaderVisible" top="8vh"
        z-index="2000">
        <blob-uploader @closeEditor="closeBlobUploader" @blobUploadError="onBlobUploaderUploadError" @blobUploaded="onBlobUploaderUploaded" :type="11"
          :accepts="'.png,.jpg,.jpeg'" :isVisible="blobUploaderVisible" :isAutoSave="true"></blob-uploader>
      </el-dialog>
      <el-dialog center title="图片预览" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="imagePreviewVisible" top="8vh" z-index="2000"
        @closed="closeImagePreview">
        <div class="cs-demo-image-preview__lazy">
          <div class="block">
            <img :src="previewImageSrc" lazy>
          </div>
        </div>
      </el-dialog>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { getPaymentImgList,getStore, getEMTExampleImgList, toDecimal } from "@/config/mUtils.js";

import { getGlobalPriceSettingByType } from "@/service/globalPriceSetting.service.js";
import { getPaymentTypes } from "@/service/finance.service";
import { getSharedAccessSignature } from "@/service/blobStorage.service";
import { removeFileStorage } from "@/service/blobStorage.service";
import {getUniversityEmailAccount} from "@/service/common.service";

const default_dataModel = {
  id: 0,
  paymentTypeId: 0,
  name: null,
  email: null,
  comment: null,
  imageFiles: [],
};

export default {
  name: "paymentBillEditor",
  mixins: [mixinDevice],
  components: {
    blobUploader: () => import("@/components/fileHandler/blobUploader"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
      default: () => ({
        id: 0,
        hasEMT: true,
        currency: 2,
        paymentAmount: 0,
        paymentTypeId: 0,
        paymentDate: null,
        name: null,
        email: null,
        comment: null,
        imageFiles: [],
      }),
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      priceSettings: {
        paymentCommissionRate: 0,
      },
      paymentTypes: [],
      autonomousPaymentTypes:[],
      rules: {
        name: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请填写支付邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "邮箱格式错误",
            trigger: "blur",
          },
        ],
      },
      dataModel: Object.clone(default_dataModel),
      blobUploaderVisible: false,
      sasKey: null,
      imagePreviewVisible: false,
      previewImageSrc: null,
      mailAccount: "XXX@speedupedu.com",
      umtExampleImgList:[],
      emtExampleImgSrc: "",
      isSaving: false
    };
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.loadAutonomousPaymentTypes();
    this.umtExampleImgList = getEMTExampleImgList();
    if (this.USERMANAGER.isStudent){
      getUniversityEmailAccount().then(result =>{
        if (result && result.success){
          this.mailAccount = result.data;
          let name = this.mailAccount.replace("@speedupedu.com", ""); 
          this.emtExampleImgSrc = this.umtExampleImgList[name];
        }
      });
    }
    
    this.init();
    this.reloadVisible();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    paymentTypeDisabled() {
      return this.readonly || !this.data.paymentAmount || !!this.data.id;
    },
    paymentName() {
      let value = this.GLOBAL.enumPaymentType.getDesc(
        this.dataModel.paymentTypeId
      );
      return !!value ? `${value}付款` : String.empty;
    },
    paymentDateText() {
      let date = this.data.paymentDate || new Date();
      return this.$moment(date).format("YYYY/MM/DD");
    },
    hasServiceCharge() {
      let objPaymentType = this.__findPaymentType(this.dataModel.paymentTypeId);
      return !!objPaymentType ? objPaymentType.HasServiceCharge : false;
    },
    pcPrice() {
      if (!this.hasServiceCharge) return 0;

      let amount = parseFloat(this.data.paymentAmount);
      if (isNaN(amount)) return 0;

      let value = amount * this.priceSettings.paymentCommissionRate;
      return toDecimal(value);
    },
    pcRateView: function() {
      let result = this.priceSettings.paymentCommissionRate * 100 + "%";

      return result;
    },
  },
  methods: {
    loadAutonomousPaymentTypes(){
      let excepts = [];
      if (this.data && !this.data.hasEMT){
        excepts = [this.GLOBAL.enumPaymentType.emt];
      }
      this.autonomousPaymentTypes = this.GLOBAL.enumPaymentType.getOptionsForCheckpay(excepts);
    },
    async loadPriceSettings() {
      try {
        let pcRate = this.GLOBAL.globalPriceType.paymentCommissionRate;
        let result = await getGlobalPriceSettingByType(pcRate);
        if (!!result && result.success) {
          this.priceSettings.paymentCommissionRate = result.data.Value;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadPaymentTypes() {
      try {
        let result = await getPaymentTypes(true);
        this.paymentTypes = !!result && result.success ? result.data : [];
      } catch (error) {
        console.error(error);
      }
    },
    async loadSharedAccessSignatureFromServer() {
      try {
        let result = await getSharedAccessSignature(true);
        if (!!result && result.success) {
          this.sasKey = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async removeFileStorageToServer(id, isDelete = false) {
      try {
        let result = await removeFileStorage(id, isDelete);

        return !!result && result.success && result.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async init() {
      await this.loadPriceSettings();
      await this.loadPaymentTypes();
      await this.loadSharedAccessSignatureFromServer();
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) this.dialogVisible = newValue;
    },
    resetData() {
      this.isSaving = false;
      this.dataModel = Object.clone(default_dataModel);
    },
    reloadDataFromProps() {
      let newData = Object.clone(default_dataModel);
      newData.id = this.data.id;
      newData.paymentTypeId = this.data.paymentTypeId;
      newData.name = this.data.name;
      newData.email = this.data.email;
      newData.comment = this.data.comment;
      newData.imageFiles = this.data.imageFiles;
      this.dataModel = newData;
      this.loadAutonomousPaymentTypes();
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.closeDialog();
    },
    completedPayment() {
      let isValid = this.checkAllInputs();
      if (!isValid) return;
      // console.log(typeof(this.data.paymentAmount));
      // console.log("data.paymentAmount",this.data.paymentAmount);
      // console.log("this.pcPrice",this.pcPrice);
      // console.log("total",this.data.paymentAmount + this.pcPrice);
      // return;
      if (!this.dataModel.paymentTypeId) {
        this.$message.warning("请选择支付方式。");
        return;
      }

      if (
        this.dataModel.paymentTypeId === this.GLOBAL.enumPaymentType.emt &&
        this.dataModel.imageFiles.length === 0
      ) {
        this.$message.warning("请上传支付截图。");
        return;
      }
      this.isSaving = true;

      let dataOut = {
        id: this.dataModel.id,
        paymentTypeId: this.dataModel.paymentTypeId,
        paymentAmount: this.data.paymentAmount,
        serviceCharge: this.pcPrice,
        name: this.dataModel.name,
        email: this.dataModel.email,
        comment: this.dataModel.comment,
        imageFiles: this.dataModel.imageFiles,
      };
      this.$emit("completed", dataOut);
    },
    onPaymentTypeIconClick(typeId) {
      this.dataModel.paymentTypeId = typeId;
    },
    checkAllInputs(value) {
      let isValid = true;

      let inputForm = this.$vueRefStore.getChildrenRef("inputForm");
      if (!!inputForm) {
        inputForm.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      return isValid;
    },
    openBlobUploader() {
      this.blobUploaderVisible = true;
    },
    closeBlobUploader() {
      this.blobUploaderVisible = false;
    },
    onBlobUploaderUploadError() {},
    onBlobUploaderUploaded(data) {
      this.$nextTick(async () => {
        // if (this.dataModel.imageFiles.length > 0) {
        //   await this.removeImage();
        // }

        if (Object.typeOf(data) === "array") {
          data.forEach((item) => {
            this.dataModel.imageFiles.push({
              Id: 0,
              FileId: item.FileId,
              FileName: item.FileName,
              Path: item.Path,
            });
          });
        } else {
          this.dataModel.imageFiles.push({
            Id: 0,
            FileId: data.FileId,
            FileName: data.FileName,
            Path: data.Path,
          });
        }

        this.closeBlobUploader();
      });
    },
    async removeImage(index = 0) {
      let result = true;
      let imgFile = this.dataModel.imageFiles[index];

      if (!imgFile.Id) {
        result = await this.removeFileStorageToServer(imgFile.FileId, true);
      }

      if (result) {
        this.dataModel.imageFiles.splice(index, 1);
      }
    },
    onRemoveImageClick(index = 0) {
      this.$confirm("您确认要删除该图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.removeImage(index);
        })
        .catch(() => {});
    },
    showImagePreview(pictureUrl) {
      this.previewImageSrc = this.__convertImageUrl(pictureUrl);
      this.imagePreviewVisible = true;
    },
    closeImagePreview() {
      this.previewImageSrc = null;
      this.imagePreviewVisible = false;
    },

    __findPaymentType(typeId) {
      let result = null;

      for (let i = 0; i < this.paymentTypes.length; i++) {
        let type = this.paymentTypes[i];
        if (type.Id == typeId) {
          result = type;
          break;
        }
      }

      return result;
    },
    __convertImageUrl(originalUrl) {
      if (!this.sasKey) {
        return "";
      }

      return originalUrl + this.sasKey;
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  text-align: center;
  padding: 0 60px;
  padding-top: 30px;
}

.cs-emt-example-imgList{
  span{
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  img{
    width: 500px;
  }
  margin-bottom: 10px;
}

.paymentType-group {
  line-height: 48px;
  margin-right: 20px;
  width: 60%;

  .paymentType-item {
    .el-card {
      width: 48px;
      border: 0px;
      background-color: transparent;
      margin-left: auto;
      margin-right: auto;
    }

    .icon {
      padding: 0;
      width: 32px;
      height: 32px;
      cursor: pointer;

      img {
        vertical-align: middle;
        text-align: center;
        width: 32px;
        height: 32px;
      }
    }
  }

  .el-radio {
    vertical-align: middle;
    text-align: center;
    margin: 0;
    padding: 0 8px;

    /deep/ .el-radio__label {
      display: none;
    }
  }

  .el-link {
    &.is-disabled {
      opacity: 0.5;

      .icon {
        cursor: not-allowed;
      }
    }
  }
}

.payment-info,
.payment-inputs {
  width: 100%;

  table {
    width: 100%;
    text-align: left;

    td {
      padding: 5px 10px;

      &.label {
        width: 30%;
        text-align: right;
      }
    }
  }
}

.payment-inputs {
  p {
    text-align: left;
  }

  td.label .label__inner {
    margin-bottom: 10px;
  }

  .el-form-item {
    margin-bottom: 10px;

    .el-input {
      width: 70%;
    }
  }
}

.cs-demo-image__lazy {
  width: 80px;
  .block {
    width: 64px;
    height: 64px;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}

.cs-demo-image-preview__lazy {
  .block {
    text-align: center;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payApi/paymentBillEditor.vue